<template>
  <v-layout row wrap>
    <v-flex xs12 class="pt-0">
      <v-data-table
        :headers="headers"
        :items="listItems"
        :total-items="totalItems"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="ch-table-list"
      >
        <template slot="headers" slot-scope="props">
          <tr>
            <th v-for="header in props.headers" :key="header.text"
              class="text-xs-left"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon v-if="sortableList.includes(header.value)">arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left" width="20%">
            <button class="ch-menu-btn m-0 pl-3 pr-3 btn error" @click="openDeleteDialog(props.item.delete)">
              <i class="fas fa-trash-alt"></i>
              <span class="ml-2">Delete</span>
            </button>
          </td>
          <td class="text-xs-left" width="20%">{{ props.item.name }}</td>
          <td class="text-xs-left" width="20%">{{ props.item.checkin_at | moment("YYYY-MM-DD HH") }}</td>
          <td class="text-xs-left" width="20%">{{ props.item.checkout_at | moment("YYYY-MM-DD HH") }}</td>
          <td class="text-xs-left" width="10%">{{ props.item.created_at | moment("YYYY-MM-DD HH:mm:ss") }}</td>
        </template>
      </v-data-table>
    </v-flex>
    <v-dialog v-model="deleteDialog" max-width="300">
      <v-card>
        <v-card-title class="headline">Are you sure you want to delete the Mobile Key?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error darken-1" flat="flat" @click.native="deleteDialog = false">Cancel</v-btn>
          <v-btn color="primary darken-1" flat="flat" @click.native="deleteMobileKey">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
  // import _ from 'lodash';
  import { storeFilterEventBus } from '@/components/customized-components/storeFilterEventBus';
  import { doorlockMobileKeyEventBus } from '@/components/admin/doorlocks/doorlockMobileKeyEventBus';
  // import api from '../../../api';
  // TODO: dummy data
  import testDoorlocksMobileKeyList from './testDoorlocksMobileKeyList.json';

  export default {
    // TODO: Doorlock 관련 booking이 추가 될 때, props - 'doorlockBookingId'
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        //--------------------------------------------------------------------
        // TODO: API 대용, 추후 제거
        //--------------------------------------------------------------------
        dummy: null,
        //--------------------------------------------------------------------
        // NOTE: first init
        isInit: false,
        // NOTE: Table List
        loading: false,
        pagination: {
          sortBy: null,
          descending: null,
          rowsPerPage: 20,
        },
        totalItems: 0,
        visibleRoomName: false,
        headers: [
          { text: 'Delete', value: 'delete', align: 'left', sortable: false },
          { text: 'Name', value: 'name', align: 'left' },
          { text: 'Checkin At', value: 'checkin_at', align: 'left' },
          { text: 'Checkout At', value: 'checkout_at', align: 'left' },
          { text: 'Created At', value: 'created_at', align: 'left' },
        ],
        rowsPerPageItems: [20, 50],
        sortableList: ['name', 'checkin_at', 'checkout_at', 'created_at'],
        // NOTE: Data
        listItems: [],    // 실제 서버에서 받아온 원본 리스트
        filter: [],       // 쿼리문을 담을 배열
        deleteDialog: false,
        mobileKey: null,
      };
    },
    methods: {
      //--------------------------------------------------------------------
      // TODO: API 대용, 추후 제거
      //--------------------------------------------------------------------
      getDoorlocksMobileKeyList() {
        let searchFilter = null;
        if (this.filter.length > 0) {
          console.log('filter is not empty');
          searchFilter = this.filter.map((item) => {
            const obj = {};
            obj.search = item.search;
            obj.searchCategory = item.searchCategory;
            return obj;
          });
          this.dummy = testDoorlocksMobileKeyList.filter((item) => {
            let match = null;
            searchFilter.map((filterItem) => {
              match = item[filterItem.searchCategory].includes(filterItem.search);
              return filterItem;
            });
            return match;
          });
        } else {
          console.log('filter empty');
          this.dummy = testDoorlocksMobileKeyList.slice();
        }
        this.listItems = this.dummy.slice();
      },
      changeSort(column) {
        if (this.sortableList.includes(column)) {
          if (this.pagination.sortBy === column) {
            this.pagination.descending = !this.pagination.descending;
          } else {
            this.pagination.sortBy = column;
            this.pagination.descending = false;
          }
        }
      },
      // TODO: API 연동 후 필요
      openDeleteDialog(id) {
        console.log(id);
        this.deleteDialog = true;
        this.mobileKey = id;
      },
      // TODO: API 연동 후 필요
      deleteMobileKey() {
        this.deleteDialog = false;
        this.mobileKey = null;
        console.info('API 호출!!!');
      },
      //--------------------------------------------------------------------
      // init() {
      //   if (_.isEmpty(this.storeFilter)) {
      //     this.getDoorlocksMobileKeyList();
      //   }
      // },
      // getDoorlocksMobileKeyList() {
      //   this.loading = true;
      //   const sortStr = this.pagination.sortBy;
      //   let orderStr = null;
      //   if (this.pagination.descending === null) {
      //     orderStr = null;
      //   } else if (this.pagination.descending === false) {
      //     orderStr = 'asc';
      //   } else if (this.pagination.descending === true) {
      //     orderStr = 'desc';
      //   }
      //   const querystring = {
      //     sort: sortStr,
      //     order: orderStr,
      //     offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
      //     limit: this.pagination.rowsPerPage,
      //     pagination: true,
      //   };
      //   for (let index = 0; index < this.filter.length; index += 1) {
      //     querystring[this.filter[index].searchCategory] = this.filter[index].search;
      //   }
      //   if (this.hotelsBookingId) querystring.hotel_id = this.hotelsBookingId;
      //   api.getDoorlocksMobileKeyList(querystring)
      //   .then((result) => {
      //     if (result.status === 200) {
      //       this.listItems = result.data.items.map((item) => {
      //         const rebuildItem = item;
      //         switch (rebuildItem.status) {
      //           case 'created':
      //             rebuildItem.status = 'Not assigned';
      //             break;
      //           case 'issued':
      //             rebuildItem.status = 'Assigned';
      //             break;
      //           case 'canceled':
      //             rebuildItem.status = 'Canceled';
      //             break;
      //           default:
      //             rebuildItem.status = '';
      //             break;
      //         }
      //         return rebuildItem;
      //       });
      //       this.totalItems = result.data.total;
      //       this.loading = false;
      //     }
      //   })
      //   .catch((err) => {
      //     this.alert.type = 'error';
      //     this.alert.color = 'red';
      //     this.alert.message = err.response.data.message;
      //     this.alertOccur();
      //     this.loading = false;
      //   });
      // },
      // changeSort(column) {
      //   if (this.sortableList.includes(column)) {
      //     if (this.pagination.sortBy === column) {
      //       this.pagination.descending = !this.pagination.descending;
      //     } else {
      //       this.pagination.sortBy = column;
      //       this.pagination.descending = false;
      //     }
      //   }
      // },
    },
    watch: {
      pagination: {
        deep: true,
        handler() {
          if (this.isInit) {
            console.log('handler');
            this.getDoorlocksMobileKeyList();
          }
        },
      },
    },
    computed: {
      pages() {
        /* eslint max-len: ["error", { "code": 200 }] */
        return this.pagination.rowsPerPage ? Math.ceil(this.listItems.length / this.pagination.rowsPerPage) : 0;
      },
    },
    mounted() {
      //--------------------------------------------------------------------
      // TODO: API 대용, 추후 제거
      //--------------------------------------------------------------------
      console.log('doorlocksMobilekeyList mount');
      this.getDoorlocksMobileKeyList();
      doorlockMobileKeyEventBus.$on('initFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        this.getDoorlocksMobileKeyList();
      });
      doorlockMobileKeyEventBus.$on('customFilter', (obj) => {
        this.filter = Object.values(obj).filter(item => item.search !== null);
        this.pagination.page = 1;
        this.getDoorlocksMobileKeyList();
      });
      //--------------------------------------------------------------------
      // console.log('anonyBookinglist mount');
      // this.init();
      // this.$nextTick(() => {
      //   this.isInit = true;
      // });
      // this.$nextTick(() => {
      //   if (!_.isEmpty(this.storePage)) {
      //     this.pagination = Object.assign({}, this.storePage);
      //     this.getDoorlocksMobileKeyList();
      //   }
      // });
      // doorlockMobileKeyEventBus.$on('initFilter', (obj) => {
      //   this.filter = Object.values(obj).filter(item => item.search !== null);
      //   this.getDoorlocksMobileKeyList();
      // });
      // doorlockMobileKeyEventBus.$on('customFilter', (obj) => {
      //   this.filter = Object.values(obj).filter(item => item.search !== null);
      //   this.pagination.page = 1;
      //   this.getDoorlocksMobileKeyList();
      // });
      // doorlockMobileKeyEventBus.$on('reloadList', () => this.getDoorlocksMobileKeyList());
    },
    updated() {
      storeFilterEventBus.$emit('setPage', this.pagination);
    },
  };
</script>

<style lang="scss" scoped>
.ch-menu-btn {
  box-shadow: none;
}
</style>




// WEBPACK FOOTER //
// src/components/admin/doorlocks/DoorlocksMobileKeyList.vue